// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { Typography } from "@insite/mobius/index";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { xIsAuthenticated } from "@stanion/App/Store/Selectors/GeneralSelectors";
import { color, mergeWithCss } from "@stanion/XDL/Utilities";
import React, { FC, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    labelOverride?: string;
    extendedStyles?: XngSignInButtonStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    isAuthenticated: xIsAuthenticated(state),
    currentLocation: getLocation(state),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface XngSignInButtonStyles {
    container?: InjectableCss;
    containerSecondLevel?: InjectableCss;
    textWrapper?: TypographyProps;
    link?: LinkPresentationProps;
}
export const xngSignInButtonStyles: XngSignInButtonStyles = {
    container: {
        css: css`
            border: 1px solid ${color("common.border")};
            padding: 17px;
        `,
    },
    containerSecondLevel: {
        css: css`
            padding: 12px;
            background-color: ${color("common.ui2")};
        `,
    },
    textWrapper: {
        size: 14,
        lineHeight: "22px",
        css: css`
            a {
                > span {
                    &&& {
                        color: ${color("common.ui2")};
                        font-weight: bold;
                    }
                }
            }
        `,
    },
};

const XngSignInButton: FC<Props> = ({ isAuthenticated, currentLocation, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(xngSignInButtonStyles, extendedStyles));
    if (isAuthenticated) {
        return null;
    }

    const returnUrl = currentLocation.pathname + currentLocation.search;

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.containerSecondLevel}>
                <Typography {...styles.textWrapper}>{siteMessage("Pricing_SignInForPrice", returnUrl)}</Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(XngSignInButton);
